module.exports = __webpack_public_path__ + "static/media/next2.441e9ff4.png";